import React from "react";
import styled from "styled-components";
import TopNavbar from "../components/Nav/TopNavbar";
import Footer from "../components/Sections/Footer";

export default function VisionBoardPage({ navigate }) {
  return (
    <>
      <TopNavbar navigate={navigate} currentPage="visionboard" />

      {/* ===== PAGE HERO ===== */}
      <PageHero className="pageHero">
        <div className="container flexSpaceCenter">
          <HeroText className="hero-in">
            <PageTag className="pinkBg whiteColor radius6">המוצר שלנו</PageTag>
            <h1 className="font60 extraBold darkColor heroTitle" style={{ marginTop: "15px", lineHeight: "1.1" }}>
              לוח חזון 🌟
            </h1>
            <p className="font18 darkColor" style={{ marginTop: "20px", lineHeight: "1.7", maxWidth: "500px" }}>
              כלי עוצמתי חזותי שמסייע להמחיש ולמקד מטרות,
              חלומות ושאיפות אישיות. כי אין כמו מראה עיניים...
            </p>
          </HeroText>
          <HeroImageBox>
            {/* IMAGE PLACEHOLDER — swap for a photo of a vision board */}
            <HeroImgPlaceholder className="radius8">
              <span>📸 תמונת גיבור: לוח חזון</span>
            </HeroImgPlaceholder>
          </HeroImageBox>
        </div>
      </PageHero>

      {/* ===== WHAT IS A VISION BOARD ===== */}
      <Section className="lightBg">
        <div className="container">
          <TwoCol>
            <TextCol className="slide-right">
              <SectionLabel className="font15 semiBold" style={{ color: "var(--rose-600)" }}>הכרות</SectionLabel>
              <h2 className="font40 extraBold darkColor" style={{ margin: "10px 0 20px" }}>
                אז מה זה לוח חזון?
              </h2>
              <BodyText className="font15">
                לוח חזון הוא כלי עוצמתי חזותי שמסייע להמחיש ולמקד מטרות, חלומות ושאיפות אישיות.
              </BodyText>
              <BodyText className="font15" style={{ marginTop: "16px" }}>
                מדובר בלוח שעליו מודבקות תמונות, ציטוטים, מילים או סמלים שמייצגים
                את הדברים שרוצים להשיג בחיים.
              </BodyText>
              <BodyText className="font15" style={{ marginTop: "16px" }}>
                מטרתו של לוח החזון היא להוות מקור השראה ולהזכיר לנו את היעדים והשאיפות שלנו,
                ולחזק את המוטיבציה להתמקד בהם.
              </BodyText>
              <BodyText className="font15" style={{ marginTop: "16px" }}>
                את לוח החזון כדאי לתלות בפינה שהיא אולי קצת אישית אך שתאפשר
                לנו לראותו לעיתים קרובות...
              </BodyText>
            </TextCol>
            <ImageCol className="slide-left">
              {/* IMAGE PLACEHOLDER — vision board example full photo */}
              <ImgPlaceholder className="radius8" style={{ background: "var(--grad-blush)", height: "400px" }}>
                <span>📸 דוגמת לוח חזון</span>
              </ImgPlaceholder>
            </ImageCol>
          </TwoCol>
        </div>
      </Section>

      {/* ===== BENEFITS ===== */}
      <Section>
        <div className="container">
          <SectionHeader>
            <h2 className="font40 extraBold darkColor">במה לוח חזון יכול לעזור לנו?</h2>
            <p className="font15 greyColor">שישה יתרונות מרכזיים</p>
          </SectionHeader>
          <BenefitsGrid className="stagger-reveal">

            <BenefitCard>
              <BenefitImgBox>
                {/* IMAGE PLACEHOLDER — clarity/focus image */}
                <ImgPlaceholder className="radius8" style={{ background: "var(--tint-rose)", height: "180px" }}>
                  <span>📸 בהירות</span>
                </ImgPlaceholder>
              </BenefitImgBox>
              <BenefitIcon>🔍</BenefitIcon>
              <BenefitTitle className="font20 extraBold darkColor">בהירות</BenefitTitle>
              <BenefitText className="font14">
                לוח חזון מאפשר להגדיר ולהבהיר מה רוצים להשיג בחיים, בין אם מדובר בקריירה,
                בריאות, רווחה אישית או קשרים חברתיים.
              </BenefitText>
            </BenefitCard>

            <BenefitCard>
              <BenefitImgBox>
                {/* IMAGE PLACEHOLDER — motivation/energy image */}
                <ImgPlaceholder className="radius8" style={{ background: "var(--tint-butter)", height: "180px" }}>
                  <span>📸 מוטיבציה</span>
                </ImgPlaceholder>
              </BenefitImgBox>
              <BenefitIcon>⚡</BenefitIcon>
              <BenefitTitle className="font20 extraBold darkColor">מוטיבציה</BenefitTitle>
              <BenefitText className="font14">
                הצבת המטרות והחזונות במקום שרואים כל יום יכולה להניע אותנו לפעול
                ולהתקדם לעבר השגתן.
              </BenefitText>
            </BenefitCard>

            <BenefitCard>
              <BenefitImgBox>
                {/* IMAGE PLACEHOLDER — planning image */}
                <ImgPlaceholder className="radius8" style={{ background: "var(--tint-rose)", height: "180px" }}>
                  <span>📸 תכנון</span>
                </ImgPlaceholder>
              </BenefitImgBox>
              <BenefitIcon>📋</BenefitIcon>
              <BenefitTitle className="font20 extraBold darkColor">תכנון</BenefitTitle>
              <BenefitText className="font14">
                תהליך יצירת לוח החזון מעודד אותנו לחשוב על צעדים קונקרטיים
                שניתן לנקוט כדי להשיג את המטרות שלנו.
              </BenefitText>
            </BenefitCard>

            <BenefitCard>
              <BenefitImgBox>
                {/* IMAGE PLACEHOLDER — focus image */}
                <ImgPlaceholder className="radius8" style={{ background: "var(--tint-butter)", height: "180px" }}>
                  <span>📸 מיקוד</span>
                </ImgPlaceholder>
              </BenefitImgBox>
              <BenefitIcon>🎯</BenefitIcon>
              <BenefitTitle className="font20 extraBold darkColor">מיקוד</BenefitTitle>
              <BenefitText className="font14">
                לוח חזון מסייע להימנע מהסחות דעת ולשמור על מיקוד
                במטרות העיקריות שלנו.
              </BenefitText>
            </BenefitCard>

            <BenefitCard>
              <BenefitImgBox>
                {/* IMAGE PLACEHOLDER — visualization/dreams image */}
                <ImgPlaceholder className="radius8" style={{ background: "var(--tint-rose)", height: "180px" }}>
                  <span>📸 ויזואליזציה</span>
                </ImgPlaceholder>
              </BenefitImgBox>
              <BenefitIcon>👁️</BenefitIcon>
              <BenefitTitle className="font20 extraBold darkColor">ויזואליזציה</BenefitTitle>
              <BenefitText className="font14">
                לוח חזון מספק ייצוג חזותי של מה שרוצים להשיג.
                אין כמו מראה עיניים...
              </BenefitText>
            </BenefitCard>

            <BenefitCard>
              <BenefitImgBox>
                {/* IMAGE PLACEHOLDER — positive reinforcement image */}
                <ImgPlaceholder className="radius8" style={{ background: "var(--tint-butter)", height: "180px" }}>
                  <span>📸 חיזוק חיובי</span>
                </ImgPlaceholder>
              </BenefitImgBox>
              <BenefitIcon>💪</BenefitIcon>
              <BenefitTitle className="font20 extraBold darkColor">חיזוק חיובי</BenefitTitle>
              <BenefitText className="font14">
                צפייה במטרות שלנו מבעד לתמונות ומילים חיוביות יכולה לשפר
                את התחושה העצמית ולחזק את האמונה בהצלחה שלנו.
              </BenefitText>
            </BenefitCard>

          </BenefitsGrid>
        </div>
      </Section>

      {/* ===== MY VISION BOARD ===== */}
      <Section className="coralBg">
        <div className="container">
          <TwoCol>
            <ImageCol className="slide-left">
              <MyBoardWrapper>
                {/* IMAGE PLACEHOLDER — YOUR PERSONAL VISION BOARD photo */}
                <MyBoardImg className="radius8">
                  <span>📸 לוח החזון האישי שלי</span>
                  <small style={{ display: "block", marginTop: "10px", opacity: 0.7 }}>
                    החליפי בתמונה האמיתית של הלוח שלך
                  </small>
                </MyBoardImg>
                {/* IMAGE PLACEHOLDER — detail/close-up of the board */}
                <BoardDetailImg className="radius8" style={{ background: "var(--tint-mauve)" }}>
                  <span>📸 פרט מהלוח</span>
                </BoardDetailImg>
              </MyBoardWrapper>
            </ImageCol>
            <TextCol className="slide-right">
              <SectionLabel className="font15 semiBold" style={{ color: "var(--rose-600)" }}>אישי</SectionLabel>
              <h2 className="font40 extraBold darkColor" style={{ margin: "10px 0 20px" }}>
                וזה לוח החזון שלי 😊😊
              </h2>
              <BodyText className="font15">
                בטוחה שגם מבלי שאסביר אפשר להבין לפחות חלק מהחלומות שלי.
              </BodyText>
              <BodyText className="font15" style={{ marginTop: "16px" }}>
                לוחות חזון הם כלי גמיש: אנשים משתמשים בהם להציג את החלומות הגדולים שלהם
                (וגם החלומות הקטנים...) בתחומים כמו קריירה, משפחה, בריאות או התפתחות אישית.
              </BodyText>
              {/* IMAGE PLACEHOLDER — inspiring quote card or detail */}
              <QuoteImgBox className="radius8">
                <span>📸 כרטיס ציטוט / פרט מהלוח</span>
              </QuoteImgBox>
            </TextCol>
          </TwoCol>
        </div>
      </Section>

      {/* ===== GALLERY ===== */}
      <GallerySection className="lightBg">
        <div className="container">
          <SectionHeader>
            <h2 className="font30 extraBold darkColor">גלריית לוחות חזון ✨</h2>
            <p className="font14 greyColor">השראה מסדנאות שלנו</p>
          </SectionHeader>
          <GalleryMasonry>
            <GalleryTall>
              {/* IMAGE PLACEHOLDER — tall vision board photo */}
              <ImgPlaceholder className="radius8" style={{ background: "var(--tint-rose)", height: "100%" }}>
                <span>📸 לוח חזון 1</span>
              </ImgPlaceholder>
            </GalleryTall>
            <GallerySmallCol>
              <GallerySmallItem>
                {/* IMAGE PLACEHOLDER */}
                <ImgPlaceholder className="radius8" style={{ background: "var(--tint-butter)", height: "100%" }}>
                  <span>📸 לוח 2</span>
                </ImgPlaceholder>
              </GallerySmallItem>
              <GallerySmallItem>
                {/* IMAGE PLACEHOLDER */}
                <ImgPlaceholder className="radius8" style={{ background: "var(--tint-mauve)", height: "100%" }}>
                  <span>📸 לוח 3</span>
                </ImgPlaceholder>
              </GallerySmallItem>
            </GallerySmallCol>
            <GallerySmallCol>
              <GallerySmallItem>
                {/* IMAGE PLACEHOLDER */}
                <ImgPlaceholder className="radius8" style={{ background: "var(--tint-butter)", height: "100%" }}>
                  <span>📸 לוח 4</span>
                </ImgPlaceholder>
              </GallerySmallItem>
              <GallerySmallItem>
                {/* IMAGE PLACEHOLDER */}
                <ImgPlaceholder className="radius8" style={{ background: "var(--tint-rose)", height: "100%" }}>
                  <span>📸 לוח 5</span>
                </ImgPlaceholder>
              </GallerySmallItem>
            </GallerySmallCol>
          </GalleryMasonry>
        </div>
      </GallerySection>

      {/* ===== CTA ===== */}
      <CTASection className="pinkBg">
        <div className="container textCenter">
          <h2 className="font40 extraBold whiteColor">מוכנה להתחיל? 🌟</h2>
          <p className="font18 whiteColor" style={{ margin: "20px auto", maxWidth: "500px", lineHeight: "1.7" }}>
            יצירת לוח חזון היא מסע אל עצמך. בואי נעשה אותו יחד.
          </p>
          <CTAImageRow>
            {/* IMAGE PLACEHOLDER — workshop photo */}
            <CTAImg className="radius8">
              <span>📸 סדנת לוח חזון</span>
            </CTAImg>
            {/* IMAGE PLACEHOLDER — finished board close-up */}
            <CTAImg className="radius8">
              <span>📸 לוח מוכן</span>
            </CTAImg>
          </CTAImageRow>
          <BackBtn onClick={() => navigate("home")} className="greenBg darkColor radius8 pointer semiBold font15">
            חזרה לדף הבית
          </BackBtn>
        </div>
      </CTASection>

      <Footer navigate={navigate} />
    </>
  );
}

/* ---- Styled Components ---- */
const PageHero = styled.section`
  padding: 120px 0 80px;
  direction: rtl;
  @media (max-width: 860px) {
    padding: 100px 0 60px;
    .flexSpaceCenter { flex-direction: column; gap: 40px; }
  }
`;
const HeroText = styled.div`
  width: 55%;
  @media (max-width: 860px) { width: 100%; }
`;
const PageTag = styled.span`
  display: inline-block;
  padding: 5px 14px;
  font-size: 0.813rem;
  font-weight: 600;
`;
const HeroImageBox = styled.div`
  width: 40%;
  @media (max-width: 860px) { width: 100%; }
`;
const HeroImgPlaceholder = styled.div`
  width: 100%;
  height: 340px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  font-weight: 600;
  background: var(--grad-blush);
  color: var(--rose-600);
  border: 8px solid rgba(255, 255, 255, 0.7);
  box-shadow: var(--shadow-lift);
  animation: float 7s ease-in-out infinite;
`;
const Section = styled.section`
  padding: 80px 0;
  direction: rtl;
`;
const SectionLabel = styled.p``;
const SectionHeader = styled.div`
  text-align: center;
  margin-bottom: 50px;
  p { margin-top: 12px; }
`;
const TwoCol = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 60px;
  @media (max-width: 860px) { flex-direction: column; }
`;
const TextCol = styled.div`
  flex: 1;
`;
const ImageCol = styled.div`
  flex: 1;
`;
const ImgPlaceholder = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 0.938rem;
  font-weight: 600;
  color: var(--ink);
  text-align: center;
  padding: 20px;
`;
const BodyText = styled.p`
  line-height: 1.8;
  color: var(--ink-soft);
`;
const BenefitsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  @media (max-width: 860px) { grid-template-columns: repeat(2, 1fr); }
  @media (max-width: 500px) { grid-template-columns: 1fr; }
`;
const BenefitCard = styled.div`
  background: var(--glass-strong);
  backdrop-filter: blur(6px);
  border-radius: 1rem;
  padding: 25px;
  box-shadow: var(--shadow-card);
  transition: transform 0.6s var(--ease-spring), box-shadow 0.6s var(--ease-out);
  &:hover { transform: translateY(-8px); box-shadow: var(--shadow-lift); }
`;
const BenefitImgBox = styled.div`
  margin-bottom: 15px;
`;
const BenefitIcon = styled.div`
  font-size: 1.75rem;
  margin-bottom: 10px;
`;
const BenefitTitle = styled.h3`
  margin-bottom: 10px;
`;
const BenefitText = styled.p`
  line-height: 1.7;
  color: var(--ink-soft);
`;
const MyBoardWrapper = styled.div`
  position: relative;
`;
const MyBoardImg = styled.div`
  width: 100%;
  height: 420px;
  background: var(--grad-blush);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  font-weight: 600;
  color: var(--ink);
  text-align: center;
  padding: 20px;
`;
const BoardDetailImg = styled.div`
  position: absolute;
  bottom: -25px;
  left: -25px;
  width: 150px;
  height: 150px;
  border-radius: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--rose-600);
  text-align: center;
  padding: 10px;
  box-shadow: 0 4px 15px rgba(73, 8, 57,0.15);
  @media (max-width: 860px) { display: none; }
`;
const QuoteImgBox = styled.div`
  margin-top: 25px;
  height: 100px;
  background: var(--glass-strong);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--rose-600);
  box-shadow: 0 2px 12px rgba(73, 8, 57,0.08);
`;
const GallerySection = styled.section`
  padding: 80px 0;
  direction: rtl;
`;
const GalleryMasonry = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px;
  height: 420px;
  @media (max-width: 700px) {
    grid-template-columns: 1fr 1fr;
    height: auto;
  }
`;
const GalleryTall = styled.div`
  height: 100%;
`;
const GallerySmallCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
const GallerySmallItem = styled.div`
  flex: 1;
`;
const CTASection = styled.section`
  padding: 80px 0;
  direction: rtl;
`;
const CTAImageRow = styled.div`
  display: flex;
  gap: 20px;
  justify-content: center;
  margin: 30px 0;
  @media (max-width: 600px) { flex-direction: column; align-items: center; }
`;
const CTAImg = styled.div`
  width: 280px;
  height: 180px;
  background: rgba(255, 255, 255, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--rose-700);
  border: 2px dashed rgba(203, 29, 133, 0.45);
`;
const BackBtn = styled.button`
  padding: 14px 30px;
  font-size: 1rem;
  border: none;
  cursor: pointer;
`;
